import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImage } from '@ifeng-fe/public_method';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';
import Nav from '../nav';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

const swiperItemRef = [];
const Trivia = ({ content, guestNameList, navIndex, setNavIndex }) => {
    const swiperRef1 = useRef(null);
    const swiperRef2 = useRef(null);

    useEffect(() => {
        if (swiperRef1.current) {
            swiperRef1.current.slideToLoop(navIndex);
        }
    }, [navIndex]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            const realIndex = swiperRef1.current.realIndex;

            if (event.key === 'ArrowRight' && swiperItemRef?.[realIndex]) {
                // 按右箭头切换到下一张幻灯片
                swiperItemRef[realIndex].slideNext();
            } else if (event.key === 'ArrowLeft' && swiperItemRef?.[realIndex]) {
                // 按左箭头切换到上一张幻灯片
                swiperItemRef[realIndex].slidePrev();
            }
        };

        // 添加键盘事件监听器
        window.addEventListener('keydown', handleKeyDown);
    }, []);

    const swiperChange = (index) => {
        swiperRef1.current.slideToLoop(index);

        setNavIndex(index);
    };

    const handleSlideClick = (index) => {
        const realIndex = swiperRef1.current.realIndex;

        // console.log(swiperItemRef, realIndex, index, 'realIndex');

        if (swiperItemRef?.[realIndex]) {
            swiperItemRef[realIndex].slideToLoop(index);
        }
    };

    // console.log(swiperItemRef, '222');

    return (
        content?.[navIndex]?.isShow && (
            <div className={styles.trivia}>
                <div className={styles.nav}>
                    <Nav content={guestNameList} navIndex={navIndex} setNavIndex={setNavIndex} swiperChange={swiperChange} />
                </div>
                <img className={styles.triviaBg} src="https://x0.ifengimg.com/ucms/2025_17/58A485F719893904DBEA5ED0793ECE9BA2D57057_size368_w1920_h1080.png" />
                <img className={styles.triviaTitle} src="https://x0.ifengimg.com/ucms/2025_17/B8072FC7D8187BDBAA916D8E38170D7D6C086A68_size2_w197_h139.png" />
                <div className={styles.triviaSwiper} id="triviaSwiper">
                    <Swiper
                        allowTouchMove={false}
                        onSwiper={(swiper) => (swiperRef1.current = swiper)}
                        modules={[Navigation, Pagination]}
                        slideClass={styles.slideItem}
                        initialSlide={navIndex}
                        spaceBetween={1500}>
                        {guestNameList.map((slideItem, slideIndex) => {
                            return (
                                <SwiperSlide key={slideIndex}>
                                    {/* <div style={{ fontSize: '100px', color: 'red' }}>{slideIndex}</div> */}
                                    <div className={styles.triviaList}>
                                        <Swiper
                                            onSwiper={(swiper) => {
                                                swiperItemRef[slideIndex] = swiper;
                                                console.log(swiper, 'swiper', slideIndex);
                                            }}
                                            effect={'coverflow'}
                                            grabCursor={true}
                                            centeredSlides={true}
                                            slidesPerView={3}
                                            initialSlide={0}
                                            // spaceBetween={50}
                                            loop={true}
                                            coverflowEffect={{
                                                rotate: 50,
                                                stretch: -88,
                                                depth: 0,
                                                modifier: 1,
                                                slideShadows: false,
                                            }}
                                            pagination={{
                                                clickable: true,
                                            }}
                                            modules={[EffectCoverflow, Pagination]}
                                            onSlideChange={(swiper) => {
                                                // setTitle(slideData[swiper.realIndex].title);
                                            }}>
                                            {content?.[slideIndex]?.userImageList &&
                                                content[slideIndex].userImageList.map((item, index) => {
                                                    return (
                                                        <SwiperSlide key={index} onClick={() => handleSlideClick(index)}>
                                                            <div className="swiperItem">
                                                                <img className={styles.swiperItemPic} src={item?.userImage} />
                                                            </div>
                                                        </SwiperSlide>
                                                    );
                                                })}
                                        </Swiper>
                                    </div>
                                </SwiperSlide>
                            );
                        })}
                    </Swiper>
                </div>
            </div>
        )
    );
};

Trivia.propTypes = {
    content: PropTypes.object,
    guestNameList: PropTypes.array,
    navIndex: PropTypes.number,
    setNavIndex: PropTypes.func,
};

export default errorBoundary(Trivia);
